import React from 'react'
import { createIconComponent } from '../Icon'

const OutlinedLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"/></svg>
)

const OutlinedSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M82.618-164.001 480-823.997l397.382 659.996H82.618ZM175-216h610L480-724 175-216Zm304.789-55.693q11.942 0 20.23-8.078 8.288-8.077 8.288-20.018 0-11.942-8.078-20.23-8.077-8.288-20.018-8.288-11.942 0-20.23 8.078-8.288 8.077-8.288 20.018 0 11.942 8.078 20.23 8.077 8.288 20.018 8.288Zm-25.788-104.614h51.998v-192h-51.998v192ZM480-470Z"/></svg>
)

const FilledLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m40-120 440-760 440 760H40Zm440-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Z"/></svg>
)

const FilledSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M82.618-164.001 480-823.997l397.382 659.996H82.618Zm397.171-107.692q11.942 0 20.23-8.078 8.288-8.077 8.288-20.018 0-11.942-8.078-20.23-8.077-8.288-20.018-8.288-11.942 0-20.23 8.078-8.288 8.077-8.288 20.018 0 11.942 8.078 20.23 8.077 8.288 20.018 8.288Zm-25.788-104.614h51.998v-192h-51.998v192Z"/></svg>
)

export const WarningIcon = createIconComponent({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
})
